export const mockProjectReports = [
  {
    id: 1,
    name: '2024-HousingProduction-HOME-ActivityReport-1',
    description: '2024 CDGA Project Activity Report',
    createdAt: '11/31/2024',
    fileUrl: '/2024-HousingProduction-HOME-ActivityReport-1.pdf',
  },
  {
    id: 2,
    name: '2024BLANKACTIVITYFORM-3',
    description: 'HOMEBUYER COUNSELING PROGRAM',
    createdAt: '11/09/2024',
    fileUrl: '/2024BLANKACTIVITYFORM-3.pdf',
  },
];
